import React, { type FC } from 'react';

export const MultipleLayers: FC = () => {
    const multiLayerImage = new URL('./multi-layer.png', import.meta.url).toString();

    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Adding Multiple Layers</p>
            <p>
                Fields can contain one text layer for each frame in your template. For example, you can connect a
                Headline field across multiple frames to the same field. This allows template users to create multiple
                sizes or variants of the same content by entering content only once.
            </p>
            <p>
                When you have an existing text field, click on a text layer in any frame and click “Link to a Text
                Field” in the Text Layer panel. Next, select the field you want to link the layer to.
            </p>
            <img src={multiLayerImage} alt="multi-layer" />
        </div>
    );
};
